if (window.console == null) {
    window.console = {
        log: function (p) { },
    };
}

var
    _body,
    _window
    ;

var cfmv_FN = function () {
    cfmv = this;
    cfmv.init();
};

(function ($) {

    cfmv_FN.prototype = {

        percurseSameWay: 0,
        lastScrollTop: 0,
        lastSent: 'up',
        header: null,
        logo: null,
        logoStartEl: null,
        logoHeight: null,
        logoStartPoint: null,

        // Properties of Class
        properties: {
            timeEffects: 400, // Tempo para os efeitos
            device: 'desktop', // Device default
            loading: false,
            userbars: false,
        },

        init: function () {

            _body = jQuery('body');
            _window = jQuery(window);

            // Is admin page
            const isAdmin = _body.hasClass('wp-admin');

            // Just frontend
            if (isAdmin) return true;

            // Logo
            cfmv.header = document.querySelector( 'body > header' )
            cfmv.logo = document.querySelector( 'h1' )

            // Navigation
            cfmv.bindNavigation()

            // Sliders
            cfmv.bindScroll()

            // Bins sanfonas
            cfmv.bindSanfona()

            // Função de resize da janela do browser ( Define qual o viewport )
            cfmv.resizing();
            window.onresize = cfmv.resizing;

            // General functions
            cfmv.general();

        },


        bindSanfona: function () {

            // const $sanfona = jQuery('.piki-sanfona');
            // if ($sanfona.length) {

            //     PikiSanfona.init(
            //         $sanfona,
                    
            //     );

            // }

        },

        elementOffsetTop(element) {
            const rect = element.getBoundingClientRect();
            return rect.top + window.scrollY;
        },

        bindScroll() {

            // Hero
            let hero = document.querySelector('section.hero')
            if (!hero) {
                hero = document.querySelector('section.hero-experiencias')
            }

            // Indicators
            const indicators = (window.innerWidth >= 1280 ? document.querySelector('section.lista-experiencias') : false)

            if (hero || indicators) {

                if (indicators) {

                    // Menu
                    var menuItems = document.querySelectorAll('.menu-wrapper a')

                    // Indicators items
                    var indicatorsItems = indicators.querySelectorAll('div.item')

                    // Total indicators items
                    var indicatorsTotal = indicatorsItems.length

                }

                window.addEventListener('scroll',() => {

                    if (hero) {

                        if (window.innerWidth > 840) {

                            const height = hero.offsetHeight
                            if (window.scrollY <= height) {

                                const opacity = (100 - (window.scrollY * 100 / height)) / 100
                                hero.style.opacity = opacity

                            }

                        }
                        else {
                            hero.style.opacity = ''
                        }

                    }

                    if (indicators) {

                        let activeIndex = false;
                        for (let it = indicatorsTotal; it > 0; it--) {

                            const indic = indicatorsItems[it - 1]
                            const itemRect = indic.getBoundingClientRect();
                            if (itemRect.y <= 0 && activeIndex === false) {
                                activeIndex = (it - 1)
                            }

                        }
                        for (const [index,menuItem] of menuItems.entries()) {

                            if (activeIndex !== false && activeIndex === index) {
                                menuItem.classList.add('active')
                            }
                            else {
                                menuItem.classList.remove('active')
                            }

                        }

                    }

                })

            }

        },

        bindNavigation: () => {

            // Header elements
            cfmv.header = document.querySelector('body > header');
            if (cfmv.header) {

                cfmv.startPoint = cfmv.header.offsetHeight
                cfmv.checkScroll()

                window.addEventListener( 'scroll', cfmv.checkScroll, { passive: true } )

            }

        },

        checkScroll() {

            // Top page positioun
            const scrollTop = Piki.getPageTop()

            // Direction
            var dir = scrollTop >= cfmv.lastScrolTop ? 'to-down' : 'to-up';
            if (dir === cfmv.lastDir && dir === 'to-down') {
                const walked = (scrollTop - cfmv.lastScrolTop)
                cfmv.walked += walked
            }
            else {
                cfmv.walked = 0
            }

            // Header
            if( cfmv.header ){

                // Sticky or not
                if( scrollTop >= cfmv.startPoint ){

                    cfmv.header.classList.add('sticky')
                    cfmv.header.classList.remove('to-down','to-up')
                    cfmv.header.classList.add(dir)

                }
                else if (scrollTop === 0) {
                    cfmv.header.classList.remove('sticky','to-down','to-up')
                }

            }

            // Keep vals
            cfmv.lastDir = dir
            cfmv.lastScrolTop = scrollTop

        },

        // Função de resize da janela do browser ( Define qual o viewport )
        resizing: function () {

            var _wWidth = _window.outerWidth();

            // Define qual o viewport
            if (_wWidth < 768) {
                cfmv.properties.device = 'smartphone';
            }
            else if (_wWidth >= 768 && _wWidth <= 1279) {
                cfmv.properties.device = 'tablet';
            }
            else {
                cfmv.properties.device = 'desktop';
            }

            if (cfmv.properties.device === 'desktop') {
                _body
                    .removeClass('tablet')
                    .removeClass('mobile')
                    .addClass('desktop')
                ;
            }
            else if (cfmv.properties.device === 'tablet') {
                _body
                    .removeClass('desktop')
                    .removeClass('mobile')
                    .addClass('tablet')
                    ;
            }
            else if (cfmv.properties.device === 'smartphone') {
                _body
                    .removeClass('desktop')
                    .removeClass('tablet')
                    .addClass('mobile')
                ;
            }

            cfmv.checkScroll()

        },

        // Funções gerais de todo o site
        general: function () {

            // Hide inline messages
            const message = $('body > main > .form-status');
            if (message.length) {
                setTimeout(function () {
                    $('body>main').removeClass('with-status');
                    message.css('display','absolute').slideUp(function () { this.remove });
                },5000);
            }

        }

    };

    window.addEventListener( 'DOMContentLoaded', () => {
        imagesLoaded( 'body', () => {
            cfmv = new cfmv_FN();
        })
    });

})(jQuery);
